<template>
  <div class="content">
    <div class="content-box tree-box">
      <div class="tree-list selected">
        <div class="search-hd">
          <el-form @submit.native.prevent>
            <el-form-item>
              <h1 class="title">{{ $t('crm_company_item_serviceArea.yxcslb') }}</h1>
            </el-form-item>
            <el-form-item style=" margin-right: 0">
              <el-input :placeholder="$t('crm_company_item_serviceArea.qu_yu_ming_cheng')" v-model="filterSelected" clearable @input="changeSelected" style="width: 100%;"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="box ub-f1">
          <el-tree ref="tree2" :props="{ label: 'name', children: 'children' }" :filter-node-method="filterCheckNode" :data="tree"></el-tree>
        </div>
      </div>
      <div class="tree-list">
        <div class="search-hd">
          <el-form @submit.native.prevent>
            <el-form-item>
              <h1 class="title">{{ $t('crm_company_item_serviceArea.fu_wu_qu_yu_lie_biao') }}</h1>
            </el-form-item>
            <el-form-item style=" margin-right: 0">
              <el-input :placeholder="$t('crm_company_item_serviceArea.qu_yu_ming_cheng')" v-model="filterText" clearable @input="change" style="width: 100%;"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <!-- 区域树 -->
        <div class="box ub-f1">
          <el-tree
            ref="tree1"
            show-checkbox
            node-key="code"
            :props="{ label: 'name', children: 'children' }"
            :data="nationRegionTree"
            :filter-node-method="filterNode"
            @check-change="checkChange"
          ></el-tree>
        </div>
      </div>
    </div>
    <div class="btn-group">
      <el-button @click="$emit('previous')">{{ $t('crm_company_item_serviceArea.sybjbxx') }}</el-button>
      <el-button type="primary" @click="saveInfo">{{ $t('crm_company_item_serviceArea.xyblxrxx') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    partnerId: [String, Number],
    partnerOrgId: [String, Number]
  },
  data() {
    return {
      item: {},
      visible: false,
      filterText: '',
      filterSelected: '',
      nationRegionTree: [],
      tree: [],
      cityListSelected: [],

      // 公司ID
      companyId: '',
      companyOrgId: '',
      // 管理员ID
      organId: ''
    };
  },
  mounted() {
    // this.companyId = this.getJump('companyId');
    this.companyId = this.partnerId || '';
    this.companyOrgId = this.partnerOrgId || '';
    this.getTreeRegionTree();
  },
  methods: {
    getTreeRegionTree: function () {
      this.$getJSON(apis.NationRegionTree, { level: 3, status: 1 }).then((res) => {
        this.nationRegionTree = res.data;
        this.getHqServiceAreaList();
        // this.getCompanyDetail();
      });
    },
    getHqServiceAreaList: async function () {
      if (!this.companyId) {
        return;
      }
      const HqCityList = this.$getJSON(apis.crmServiceAreaList);
      const serviceAreaList = this.$getJSON(`${apis.serviceAreaList}/${this.companyOrgId}`);
      const cityPromise = Promise.all([HqCityList, serviceAreaList]);
      cityPromise.then((resList) => {
        //
        const HqCityListRes = resList[0];
        const HqCityListSelected = HqCityListRes.data.map(i => i.cityCode);
        const serviceAreaListRes = resList[1];
        this.cityListSelected = serviceAreaListRes.data.map(i => i.cityCode);
        this.$nextTick(() => {
          if (HqCityListSelected) {
            this.$refs.tree1.filter(HqCityListSelected);
          }
          if (this.cityListSelected) {
            this.$refs.tree1.setCheckedKeys(this.cityListSelected);
          }

        });


      });
      // this.$getJSON(apis.crmServiceAreaList).then((res) => {
      //   const HqCityListSelected = res.data.map(i => i.cityCode);
      //   if (HqCityListSelected) {
      //     this.$nextTick(() => {
      //       this.$refs.tree1.filter(HqCityListSelected);
      //       this.getCompanyDetail();
      //     });
      //   }
      // });


    },
    // getCompanyDetail: function () {
    //   if (!this.companyOrgId) {
    //     return;
    //   }
    //   this.$getJSON(`${apis.serviceAreaList}/${this.companyOrgId}`).then((res) => {
    //     this.cityListSelected = res.data.map(i => i.cityCode);
    //     if (this.cityListSelected) {
    //       setTimeout(() => {
    //         this.$nextTick(() => {
    //           this.$refs.tree1.setCheckedKeys(this.cityListSelected);
    //         });
    //       }, 500);
    //     }
    //   });
    // },
    change: function () {
      this.$nextTick(() => {
        this.$refs.tree1.filter(this.cityListSelected);
      });

    },
    changeSelected: function () {
      const nodes = this.$refs.tree1.getCheckedNodes().filter(i => i.name.indexOf(this.filterSelected) !== -1);
      this.$refs.tree2.filter(nodes);
    },
    // 选择城市
    checkChange: function () {
      if (!this.tree || !this.tree.length) {
        this.tree = this.nationRegionTree;
      }
      this.$nextTick(() => {
        const selectNodes = this.$refs.tree1.getCheckedNodes();
        this.$refs.tree2.filter(selectNodes);
      });
    },
    //  未选择树过滤
    filterNode(values, data) {
      if (this.filterText) {
        return values.includes(data.code) && data.name.includes(this.filterText);
      } else {
        return values.includes(data.code);
      }
    },
    // 选中树过滤
    filterCheckNode(nodes, data) {
      // value, data, node
      return !!nodes.find(t => t.nationRegionId === data.nationRegionId);
      // if (!value) {
      //   return true;
      // }
      // return data.value.indexOf(value) !== -1;
    },
    // 取消
    onCancel: function () {
      this.jump('/customer/renter', { refresh: true }, true);
    },
    // 保存基本信息
    saveInfo: function () {
      const selectNodes = this.$refs.tree1.getCheckedNodes();
      const list = selectNodes
        .filter(t => !t.children)
        .map(f => ({
          // afterServiceId: this.item.partnerOrgId,
          // afterServiceName: this.item.partnerName,
          cityCode: f.code,
          cityName: f.name
        }));

      const params = {};
      params.partnerId = this.companyId;
      params.partnerOrgId = this.companyOrgId;
      // params.afterServiceName = '测测测';
      params.areas = list;
      this.$postJSON(apis.serviceAreaUpdate, params).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success'
        });
        this.$emit('success', 3);
      });
    }
  }
};
</script>

<style lang="scss">
@import '../../../../style/colors.scss';
.tree-box {
  padding: 14px 24px 0;
  flex-direction: row !important;
  .title {
    font-size: 14px;
    font-weight: bold;
    color: rgba(73, 80, 87, 1);
    line-height: 14px;
    padding-bottom: 16px;
  }
  .tree-list {
    border: 1px solid rgba(228, 235, 242, 1);
    flex: 1;
    padding: 0 16px 16px;
    overflow: auto;
  }
  .selected {
    flex: 0 0 282px;
    width: 282px;
    margin-right: 16px;
  }
  .el-tree-node__label {
    font-size: 12px;
  }
}
</style>
